import {defineMessages} from 'react-intl';

export default defineMessages({
  normalSpeed: {
    defaultMessage: 'Normal',
    id: 'YoutubePlayer.Controls.Toolbar.PlaybackRateDropdown.PlaybackRateDropdownEntry.NormalSpeed',
  },
});
